{
  "help": "Ayuda",
  "info": "Información"
}
